module.exports = __webpack_public_path__ + "static/img/legend_xa.0b43651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa.png
// module id = TqRZ
// module chunks = 94